export function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}


export async function openFile(fileOpenendCallback=()=>{}) {
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = ".xml"

    input.onchange = _ => {
        // you can use this method to get file and perform respective operations
        let files = Array.from(input.files);
        const file = files[0]
        const reader = new FileReader();
        reader.addEventListener('load', (event) => {
            fileOpenendCallback(event.target.result, file.name.split(".xml")[0])
        });
        reader.readAsText(file);
    };
    input.click();
}